import './NeteaseBlot';
import './HideBlot';
import './EmotionBlot';
import ReactQuill from 'react-quill';
import {
    BilibiliFilled,
    BilibiliOutlined,
    EyeOutlined,
    FileImageFilled,
    UploadOutlined,
} from '@ant-design/icons';
import React from 'react';

import PropTypes from 'prop-types';
import {
    Button,
    Checkbox,
    Flex,
    Form,
    Input,
    message,
    Modal,
    Tooltip,
    Upload,
    UploadProps,
    Image
} from 'antd';

const emotionList = [
    '1721027376966false-7-copy-0.png',
    '1721027507177false-4-copy-0.png',
    '1721027686446false-6-copy-0.png',
    '1721027713961false-3.png',
    '1721027739484false-2.png',
    '1721027800110false-8.png',
    '1721027832946false-5-copy-0.png',
    '1721027861132false-10.png',
    '1721027879345false-9-copy-0.png',
    '1721027904001false-1-copy-0.png',
    '81d6f88ffe2d053fa132780e5741256c-1734670258.png',
    '1720885864696%C3%A7%C2%8B%C2%90%C3%A7%C2%8B%C2%90%2005.JPG',
    '1720885972712%C3%A7%C2%8B%C2%90%C3%A7%C2%8B%C2%90%2010.JPG',
    '1720886117738%C3%A7%C2%8B%C2%90%C3%A7%C2%8B%C2%90%2060.jpg',
    '1720886129765%C3%A7%C2%8B%C2%90%C3%A7%C2%8B%C2%90%2051.JPG',
    '1720886288178%C3%A7%C2%8B%C2%90%C3%A7%C2%8B%C2%90%2046.JPG',
    '1720886506758%C3%A7%C2%8B%C2%90%C3%A7%C2%8B%C2%90%2048.JPG',
    '1720886517943%C3%A7%C2%8B%C2%90%C3%A7%C2%8B%C2%90%2049.JPG',
    '1720886893497ab837d850f9cff18991a2861c1a03146.jpg',
    '172088717785720196fdecb959504707da01f733bc14f.jpg',
    '17208871908456f0e250565fa8f0e0f18151a8a7cd176.jpg'
]

function insertBili(this: { quill: any; bili: () => void }) {
    const quill = this.quill;
    const cursorPosition = quill.getSelection().index;
    Modal.confirm({
        title: '插入B站视频',
        icon: <BilibiliFilled style={{ color: '#66CCFF' }} />,
        content: (
            <Form.Item
                name='bvid'
                label='视频的BVID(只需要BVxxxxxxx)'
                extra={
                    <>
                        如视频链接https://www.bilibili.com/video/
                        <span style={{ color: 'red' }}>BV1jq4y1u7aL</span>
                        /.只需要BV1jq4y1u7aL即可~
                    </>
                }
                rules={[
                    {
                        required: true,
                        message: '请输入视频BVID!',
                    },
                    {
                        pattern: /^BV.{10}$/,
                        message: '只需要BV开头的那一串喵~',
                    },
                ]}>
                <Input placeholder='视频BVID' />
            </Form.Item>
        ),
        maskClosable: true,
        cancelText: '取消',
        okText: '插入',
        okButtonProps: { autoFocus: true, htmlType: 'submit' },
        modalRender: dom => (
            <Form
                layout='vertical'
                name='add_bili'
                clearOnDestroy
                onFinish={values => {
                    if (values.bvid) {
                        quill.insertEmbed(
                            cursorPosition,
                            'video',
                            `//player.bilibili.com/player.html?isOutside=true&bvid=${values.bvid}&autoplay=0`
                        );
                        quill.setSelection(cursorPosition + 1);
                    }
                }}>
                {dom}
            </Form>
        ),
    });
}

function insertNetease(this: { quill: any; bili: () => void }) {
    const quill = this.quill;
    const cursorPosition = quill.getSelection().index;
    Modal.confirm({
        title: '插入网易云音乐',
        icon: (
            <svg
                style={{ color: '#66CCFF' }}
                viewBox='0 0 1024 1024'
                xmlns='http://www.w3.org/2000/svg'
                width='22'
                height='22'>
                <path d='M837.766 364.816c-50.828-54.107-111.313-91.2-187.245-98.706-7.324-.728-18.983-5.028-20.404-9.983-6.595-23.064-12.826-46.784-14.283-70.54-1.64-26.6 20.368-44.744 46.748-39.425 16.724 3.389 32.392 12.389 48.277 19.457 10.968 4.883 20.988 12.389 32.32 15.923 27.472 8.49 53.378-7.725 58.589-35.78 4.408-23.684-4.41-42.922-22.154-58.153-28.857-24.776-62.998-37.748-100.054-44.743-70.977-13.409-152.74 38.768-169.648 108.908-8.453 35.088-1.712 68.755 10.457 101.51 6.486 17.527 1.968 24.595-16.032 30.862-118.308 41.32-182.508 155.436-154.49 276.075 16.506 71.123 59.465 121.733 131.862 138.604 74.44 17.344 136.818-7.943 182.62-69.192 37.056-49.516 39.133-105.519 23.976-163.197-7.943-30.242-17.198-60.156-26.672-92.948 5.575 1.094 7.397 1.203 9.037 1.786 125.486 45.436 188.959 183.858 125.232 318.813-63.91 135.325-211.911 183.348-344.362 155.072-166.26-35.526-278.955-210.93-245.286-377.62 23.61-116.924 91.564-198.32 200.253-246.342 8.27-3.68 16.797-7.251 24.266-12.28 15.595-10.53 24.886-25.687 23.064-44.633-1.93-19.93-11.878-37.93-32.136-42.011-16.215-3.28-36.036-3.68-50.72 2.696-166.223 72.107-260.848 197.994-272.869 379.884-18.655 282.566 246.128 504.023 521.296 440.882 171.833-39.424 293.167-182.18 303.986-330.804 7.105-97.248-18.619-182.763-85.625-254.11zm-309.05 234.651c-39.06 3.352-71.233-23.83-77.609-65.548-11.113-72.545 19.894-127.162 85.48-151.94 12.606-4.774 18.18-2.915 21.934 10.858 8.745 32.1 19.493 63.617 28.675 95.609 3.133 10.93 3.972 22.554 5.83 33.885-.219 42.922-25.578 73.82-64.31 77.136z' />
            </svg>
        ),
        content: (
            <>
                <Form.Item
                    name='id'
                    label='音乐ID'
                    extra={
                        <>
                            如音乐链接https://music.163.com/#/song?id=
                            <span style={{ color: 'red' }}>1956842904</span>
                            &uct2.只需要1956842904即可~
                        </>
                    }
                    rules={[
                        {
                            required: true,
                            message: '请输入音乐ID!',
                        },
                    ]}>
                    <Input placeholder='音乐ID' />
                </Form.Item>
                <Form.Item name='autoplay' valuePropName='checked'>
                    <Checkbox>自动播放</Checkbox>
                </Form.Item>
            </>
        ),
        maskClosable: true,
        cancelText: '取消',
        okText: '插入',
        okButtonProps: { autoFocus: true, htmlType: 'submit' },
        modalRender: dom => (
            <Form
                layout='vertical'
                name='add_netease'
                clearOnDestroy
                onFinish={values => {
                    if (values.id) {
                        quill.insertEmbed(
                            cursorPosition,
                            'netease',
                            `https://music.163.com/outchain/player?type=2&id=${
                                values.id
                            }&auto=${values.autoplay ? 1 : 0}&height=66`,
                            'api'
                        );
                        quill.setSelection(cursorPosition + 1);
                    }
                }}>
                {dom}
            </Form>
        ),
    });
}

function insertImage(this: { quill: any; bili: () => void }) {
    const quill = this.quill;
    const cursorPosition = quill.getSelection().index;
    const modal = Modal.confirm({});
    const props: UploadProps = {
        name: 'file',
        action: 'https://nekoda.cn/upload.php',
        headers: {
            authorization: 'authorization-text',
        },
        maxCount: 1,
        onChange(info) {
            if (info.file.status === 'done') {
                message.success(`图片上传成功`);
                quill.insertEmbed(
                    cursorPosition,
                    'image',
                    `https://nekoda.cn/usr/uploads/${info.file.response.name}`
                );
                quill.setSelection(cursorPosition + 1);
                modal.destroy();
            } else if (info.file.status === 'error') {
                message.success(`图片上传失败`);
            }
        },
    };
    modal.update({
        title: '插入图片',
        icon: <FileImageFilled style={{ color: '#66CCFF' }} />,
        content: (
            <>
                <div>图片可以上传或者是直接输入图片链接~（二选一）</div>
                <Form.Item label='Upload' name='file' valuePropName='file'>
                    <Upload {...props}>
                        <Button icon={<UploadOutlined />}>上传图片~</Button>
                    </Upload>
                </Form.Item>
                <Form.Item name='url' label='图片URL'>
                    <Input placeholder='图片URL' />
                </Form.Item>
            </>
        ),
        maskClosable: true,
        cancelText: '取消',
        okText: '插入',
        okButtonProps: { autoFocus: true, htmlType: 'submit' },
        modalRender: dom => (
            <Form
                layout='vertical'
                name='add_image'
                clearOnDestroy
                onFinish={values => {
                    if (values.url) {
                        quill.insertEmbed(cursorPosition, 'image', values.url);
                        quill.setSelection(cursorPosition + 1);
                    }
                }}>
                {dom}
            </Form>
        ),
    });
}

function insertEmotion(this: { quill: any; bili: () => void }) {
    const quill = this.quill;
    const cursorPosition = quill.getSelection().index;
    const modal = Modal.confirm({});
    const addEmotion = (emotion: string) => {
        quill.insertEmbed(
            cursorPosition,
            'emotion',
            `https://nekoda.cn/usr/uploads/${emotion}`,
            'api'
        );
        quill.setSelection(cursorPosition + 1);
        modal.destroy();
    }
    modal.update({
        title: '插入表情包',
        icon: <FileImageFilled style={{ color: '#66CCFF' }} />,
        content: (
            <>
                <Flex align='center' justify='middle' wrap>
                    {
                    emotionList.map(emotion => {
                        return <Image onClick={() => addEmotion(emotion)} preview={false} key={emotion} src={`https://nekoda.cn/usr/uploads/${emotion}`} width={75} height={75} />
                    })
                    }
                </Flex>
            </>
        ),
        maskClosable: true,
        footer: null,
    });
}

const CustomToolbar = () => (
    <div id='toolbar'>
        <select
            className='ql-header'
            defaultValue={''}
            onChange={e => e.persist()}>
            <option value='1' />
            <option value='2' />
            <option value='3' />
            <option selected />
        </select>
        <select
            className='ql-align'
            defaultValue={''}
            onChange={e => e.persist()}>
            <option selected />
            <option value='center' />
            <option value='right' />
            <option value='justify' />
        </select>
        <select className='ql-color'>
            <option value='red' />
            <option value='green' />
            <option value='blue' />
            <option value='orange' />
            <option value='violet' />
            <option selected />
        </select>
        <select className='ql-background'>
            <option value='black' />
            <option value='#66CCFF' />
            <option value='red' />
            <option value='green' />
            <option value='blue' />
            <option value='orange' />
            <option value='violet' />
            <option selected />
        </select>
        <Tooltip title='添加隐藏样式（类似萌娘百科）'>
            <button className='ql-hide'>
                <EyeOutlined />
            </button>
        </Tooltip>
        <Tooltip title='加粗'>
            <button className='ql-bold' />
        </Tooltip>

        <Tooltip title='倾斜'>
            <button className='ql-italic' />
        </Tooltip>
        <Tooltip title='下划线'>
            <button className='ql-underline' />
        </Tooltip>
        <Tooltip title='删除线'>
            <button className='ql-strike' />
        </Tooltip>
        <Tooltip title='引用'>
            <button className='ql-blockquote' />
        </Tooltip>

        <Tooltip title='有序列表'>
            <button className='ql-list' value='ordered' />
        </Tooltip>
        <Tooltip title='无序列表'>
            <button className='ql-list' value='bullet' />
        </Tooltip>

        <Tooltip title='缩进-1'>
            <button className='ql-indent' value='-1' />
        </Tooltip>
        <Tooltip title='缩进+1'>
            <button className='ql-indent' value='+1' />
        </Tooltip>

        <Tooltip title='添加链接'>
            <button className='ql-link' />
        </Tooltip>
        <Tooltip title='添加图片'>
            <button className='ql-image' />
        </Tooltip>
        <Tooltip title='添加视频'>
            <button className='ql-video' />
        </Tooltip>
        <Tooltip title='添加B站视频'>
            <button className='ql-bili'>
                <BilibiliOutlined />
            </button>
        </Tooltip>
        <Tooltip title='添加网易云音乐'>
            <button className='ql-netease'>
                <svg
                    viewBox='0 0 1024 1024'
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='20'>
                    <path d='M837.766 364.816c-50.828-54.107-111.313-91.2-187.245-98.706-7.324-.728-18.983-5.028-20.404-9.983-6.595-23.064-12.826-46.784-14.283-70.54-1.64-26.6 20.368-44.744 46.748-39.425 16.724 3.389 32.392 12.389 48.277 19.457 10.968 4.883 20.988 12.389 32.32 15.923 27.472 8.49 53.378-7.725 58.589-35.78 4.408-23.684-4.41-42.922-22.154-58.153-28.857-24.776-62.998-37.748-100.054-44.743-70.977-13.409-152.74 38.768-169.648 108.908-8.453 35.088-1.712 68.755 10.457 101.51 6.486 17.527 1.968 24.595-16.032 30.862-118.308 41.32-182.508 155.436-154.49 276.075 16.506 71.123 59.465 121.733 131.862 138.604 74.44 17.344 136.818-7.943 182.62-69.192 37.056-49.516 39.133-105.519 23.976-163.197-7.943-30.242-17.198-60.156-26.672-92.948 5.575 1.094 7.397 1.203 9.037 1.786 125.486 45.436 188.959 183.858 125.232 318.813-63.91 135.325-211.911 183.348-344.362 155.072-166.26-35.526-278.955-210.93-245.286-377.62 23.61-116.924 91.564-198.32 200.253-246.342 8.27-3.68 16.797-7.251 24.266-12.28 15.595-10.53 24.886-25.687 23.064-44.633-1.93-19.93-11.878-37.93-32.136-42.011-16.215-3.28-36.036-3.68-50.72 2.696-166.223 72.107-260.848 197.994-272.869 379.884-18.655 282.566 246.128 504.023 521.296 440.882 171.833-39.424 293.167-182.18 303.986-330.804 7.105-97.248-18.619-182.763-85.625-254.11zm-309.05 234.651c-39.06 3.352-71.233-23.83-77.609-65.548-11.113-72.545 19.894-127.162 85.48-151.94 12.606-4.774 18.18-2.915 21.934 10.858 8.745 32.1 19.493 63.617 28.675 95.609 3.133 10.93 3.972 22.554 5.83 33.885-.219 42.922-25.578 73.82-64.31 77.136z' />
                </svg>
            </button>
        </Tooltip>
        <Tooltip title='添加表情包'>
            <button className='ql-emotion'>
                <svg
                    viewBox='0 0 1024 1024'
                    version='1.1'
                    xmlns='http://www.w3.org/2000/svg'
                    width={20}
                    height={20}
                    p-id='7258'>
                    <path
                        d='M942.577061 507.011382c0-237.637282-192.632275-430.269557-430.269557-430.269557s-430.269557 192.632275-430.269557 430.269557c0 237.647515 192.632275 430.27979 430.269557 430.27979 97.553827 0 186.878225-33.189913 259.055081-87.88563 2.964518-3.363607 4.91187-7.655354 4.91187-12.479219 0-10.531867-8.541537-19.073404-19.072381-19.073404-5.465478 0-10.334369 2.168386-13.808494 5.842055l-0.242524 0c-64.584947 47.526433-144.086629 75.981509-230.422973 75.981509-215.179804 0-389.645324-174.489056-389.645324-389.656581 0-215.201294 174.466544-389.644301 389.645324-389.644301 215.202317 0 389.645324 174.443008 389.645324 389.644301 0 65.738213-15.423271 127.60219-44.186362 181.922353l0 0.321318c-0.533143 1.814322-1.108241 3.583618-1.108241 5.53097 0 10.531867 8.541537 19.073404 19.073404 19.073404 8.207939 0 15.06716-5.265934 17.745153-12.523221l0 0.13303C924.544359 645.279493 942.577061 578.258053 942.577061 507.011382zM399.574976 391.378805c0-24.028253-19.47147-43.499723-43.500746-43.499723-24.029276 0-43.478234 19.47147-43.478234 43.499723 0 24.029276 19.448958 43.479257 43.478234 43.479257C380.102483 434.858062 399.574976 415.408081 399.574976 391.378805zM669.735999 347.945597c-24.004717 0-43.476187 19.448958-43.476187 43.478234 0 24.029276 19.47147 43.500746 43.476187 43.500746 24.029276 0 43.50177-19.47147 43.50177-43.500746C713.237769 367.394554 693.766298 347.945597 669.735999 347.945597zM702.196295 630.742405c0-11.793604-9.558703-21.330818-21.350261-21.330818-1.88186 0-3.562129 0.620124-5.335519 1.084705l-0.441045 0c-49.473785 22.723537-104.548124 38.610366-162.562423 38.610366-57.130162 0-111.007233-16.130376-159.907966-38.233789l-0.177032 0c-2.300392-0.818645-4.690836-1.461281-7.2798-1.461281-11.880585 0-21.505803 9.602705-21.505803 21.485337 0 8.120958 4.513804 15.222703 11.129478 18.872836 54.209646 24.6494 113.883747 42.980907 177.319521 42.980907 63.037708 0 124.240629-18.686594 178.185238-43.046399 0.308015-0.149403 0.217964-0.11154 0.070608-0.045025C696.59574 645.928269 702.196295 638.545114 702.196295 630.742405z'
                        p-id='7259'></path>
                </svg>
            </button>
        </Tooltip>

        <Tooltip title='清除格式'>
            <button className='ql-clean' />
        </Tooltip>
    </div>
);
class Editor extends React.Component<
    { placeholder: string; onChange: any; value: any },
    {}
> {
    static modules: {
        toolbar: { container: string; handlers: any };
        clipboard: { matchVisual: boolean };
    };
    static formats: any;
    static propTypes: { placeholder: any };
    constructor(props: any) {
        super(props);
        this.state = { editorHtml: '' };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(html: any) {
        this.setState({ editorHtml: html });
        this.props.onChange(html);
    }

    render() {
        return (
            <div className='text-editor'>
                <CustomToolbar />
                <ReactQuill
                    className='editor'
                    onChange={this.handleChange}
                    placeholder={this.props.placeholder}
                    value={this.props.value}
                    modules={Editor.modules}
                    formats={Editor.formats}
                    theme={'snow'} // pass false to use minimal theme
                />
            </div>
        );
    }
}

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
Editor.modules = {
    toolbar: {
        container: '#toolbar',
        handlers: {
            bili: insertBili,
            netease: insertNetease,
            image: insertImage,
            emotion: insertEmotion
        },
    },
    clipboard: {
        matchVisual: false,
    },
};

/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
Editor.formats = [
    'align',
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'video',
    'color',
    'background',
    'netease',
    'hide',
    'emotion'
];

/*
 * PropType validation
 */
Editor.propTypes = {
    placeholder: PropTypes.string,
};

export default Editor;
